/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIKeyMetadata } from './APIKeyMetadata';
import {
    APIKeyMetadataFromJSON,
    APIKeyMetadataFromJSONTyped,
    APIKeyMetadataToJSON,
    APIKeyMetadataToJSONTyped,
} from './APIKeyMetadata';

/**
 *
 * @export
 * @interface APIKeyList
 */
export interface APIKeyList {
    /**
     *
     * @type {Array<APIKeyMetadata>}
     * @memberof APIKeyList
     */
    readonly apiKeys: Array<APIKeyMetadata>;
}

/**
 * Check if a given object implements the APIKeyList interface.
 */
export function instanceOfAPIKeyList(value: object): value is APIKeyList {
    if (!('apiKeys' in value) || value['apiKeys'] === undefined) return false;
    return true;
}

export function APIKeyListFromJSON(json: any): APIKeyList {
    return APIKeyListFromJSONTyped(json, false);
}

export function APIKeyListFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIKeyList {
    if (json == null) {
        return json;
    }
    return {

        'apiKeys': ((json['api_keys'] as Array<any>).map(APIKeyMetadataFromJSON)),
    };
}

  export function APIKeyListToJSON(json: any): APIKeyList {
      return APIKeyListToJSONTyped(json, false);
  }

  export function APIKeyListToJSONTyped(value?: Omit<APIKeyList, 'api_keys'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

    };
}
